var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zcl-player"},[_c('div',{key:_vm.currId,staticClass:"zcl-player-inner w100 h100",attrs:{"id":_vm.currId}})])}
var staticRenderFns = []

export { render, staticRenderFns }